import { graphql } from "relay-runtime";
export const ThemeQuery = graphql `
  query ThemeQuery {
    theme {
      theme
    }
  }
`;
